import { type ReactElement } from 'react';
import { sgwtConnect } from '@/sgwt/sgwtConnect.ts';
import { HealthChart} from '../components/healths/healthChart.tsx'
import { Home} from '../components/home/home.tsx'

export function HealthsPage(): ReactElement {

  if (sgwtConnect.isAuthorized())
    return <HealthChart/>;
  return <HealthChart/>;
}